<div class="notification font-body-1" [ngClass]="notificationStyle">
  <div *ngIf="layout === NotificationLayout.BLOCK_MAX_GRID; else wrappedContentTpl" class="grid-max-width grid-col-12">
    <div class="col-1-12">
      <ng-container *ngTemplateOutlet="wrappedContentTpl"></ng-container>
    </div>
  </div>
</div>

<ng-template #wrappedContentTpl>
  <div class="flex flex--self-start flex--middle" [ngClass]="contentStyle">
    <fcom-icon
      *ngIf="displayedIcon"
      class="message-type icon-medium ms-xxsmall-r ms-xsmall-l flex--nogrow message-icon"
      [category]="iconCategory"
      [name]="displayedIcon"
    ></fcom-icon>

    <div class="flex flex-1" [ngClass]="linkTextWrapped ? 'flex--wrap' : 'flex--column row-gap'">
      <span class="ps-xsmall-r flex-1 flex--self-start">
        <ng-content></ng-content>
      </span>
      <ng-container *ngIf="linkText">
        <a
          *ngIf="linkUrl"
          class="ms-xsmall-r link flex--self-start medium-type underline"
          [href]="linkUrl"
          [attr.target]="linkOpenInNewWindow ? '_blank' : null"
          [attr.rel]="linkOpenInNewWindow ? 'noopener noreferrer' : null"
          (click)="linkClick.emit($event)"
        >
          {{ linkText }}
        </a>

        <button
          *ngIf="!linkUrl"
          class="ms-xsmall-r align-left link flex--self-start medium-type underline"
          (click)="linkClick.emit($event)"
        >
          {{ linkText }}
        </button>
      </ng-container>
    </div>

    <button
      *ngIf="isClosable"
      [attr.aria-label]="i18n.closeAriaLabel | finLocalization"
      (click)="closeClick.emit($event)"
      class="ms-xsmall-r flex--nogrow flex--middle grey-600-text close-button"
    >
      <fcom-icon class="icon-small" [name]="'close-delete'"></fcom-icon>
    </button>
  </div>
</ng-template>
